module.exports = __webpack_public_path__ + "img/44.16810ff3.jpeg";